module.exports = __webpack_public_path__ + "static/image/service/m/takeout@3x.ver2_0_2.jpg?b9e8b77f";